import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants/index";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

function TrainingApprovalLead() {
  const navigate = useNavigate();
  const [Training, setTraining] = useState(
    []
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  useEffect(() => {
    fetchTrainingApprovalLead();
  }, [searchTerm]);

  const columns = {
    Employee: { text: "Employee", visible: true },
    Client: { text: "Client", visible: true },
    Project: { text: "Project", visible: true },
    Course: { text: "Course", visible: true },
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    AttendeeCount: { text: "Attendee Ct.", align: "center", visible: true },
    List: { text: "List", align: "center", visible: true },
    FeedbackScore: { text: "Score", align: "center", visible: true },
    StdRate: { text: "Std.Rate", align: "end", visible: true },
    TrainingClosedDate: { text: "Closed Date", align: "center", visible: true },
    TrainingDays: { text: "Days", align: "center", visible: true },
    CalTrainingAmount: { text: "Amount", align: "end", visible: true },
    ApplicationStatus: { text: "Status", align: "center", visible: true },
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Training Approval Lead"));
  }, []);

  function stripHTML(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  const fetchTrainingApprovalLead = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/11`
      );
      SetApiStatus(response?.status);
      const apidata = response?.data?.data;
      const cleanedData = apidata?.map((item) => ({
        ...item,
        Course: stripHTML(item.Course),
      }));
      setTraining(cleanedData);
    } catch (error) {
      console.error("Error Training Approval Lead:", error);
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={Training}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default TrainingApprovalLead;
